import React from 'react';
import { PageHero, CtaRow } from '../PublicLayout';
import { FAQS } from '../content';

export default function FaqPage() {
  return (
    <>
      <PageHero
        eyebrow="Answers"
        title="Frequently asked questions"
        subtitle="Everything you need to know about how LockedIn works."
      />
      <section className="max-w-3xl mx-auto px-4 sm:px-6 pb-10">
        <div className="space-y-3">
          {FAQS.map((item) => (
            <details key={item.q} className="group rounded-2xl border border-white/10 bg-white/[0.03] p-5">
              <summary className="cursor-pointer list-none flex items-center justify-between gap-4 text-sm font-black text-white">
                {item.q}
                <span className="text-emerald-400 group-open:rotate-45 transition-transform text-lg leading-none">+</span>
              </summary>
              <p className="text-sm text-gray-400 leading-relaxed mt-3">{item.a}</p>
            </details>
          ))}
        </div>
      </section>
      <section className="max-w-3xl mx-auto px-4 sm:px-6 py-12 text-center">
        <CtaRow />
      </section>
    </>
  );
}
